type SvgIconProps = {
    className?: string;
    style?: React.CSSProperties;
    Svg: React.ComponentType<React.SVGProps<SVGSVGElement>>;
};

function SvgIcon({
    className,
    style,
    Svg,
}: SvgIconProps) {
    return (
        <Svg
            className={className}
            style={style}
            width="1em"
            height="1em"
            fill="currentColor"
        />
    );
}

export default SvgIcon;
